import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { Dropdown, Menu } from 'semantic-ui-react';

import { ensureArray } from '../../../utils/arrayUtils';

export function computeOptions(options) {
  return orderBy(
    options.map(({ text, label, key, value, order }) => ({
      key,
      text: text || label,
      value: key || value,
      order,
    })),
    ['order', (o) => o.text?.toLowerCase()],
  );
}

function MultiSelectFilter(props) {
  const { filter, value, onChange } = props;
  const { title, placeholder, values = [] } = filter;
  const dropdownOptions = useMemo(() => computeOptions(values), [values]);

  return (
    <Menu.Item>
      <Menu.Header>{title}</Menu.Header>
      <Dropdown
        className="select--dropdown"
        fluid
        selection
        multiple
        placeholder={placeholder}
        labeled
        search
        clearable
        options={dropdownOptions}
        value={ensureArray(value)}
        onChange={(e, option) => {
          onChange(filter, option?.value || undefined);
        }}
      />
    </Menu.Item>
  );
}

MultiSelectFilter.defaultProps = {
  value: undefined,
};

MultiSelectFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
};

export default MultiSelectFilter;
